<script setup lang="ts">
import { computed } from 'vue'

import ExternalLinkButton from '@tix/ds/components/atoms/ExternalLinkButton.vue'

import { isMembershipEnabled } from '@/helpers/membership'

import { useFlags } from '@/composables/useFlags'

const props = defineProps<{
  renew?: boolean | string
}>()

const href = computed(() => (props.renew === true || props.renew === 'true' ? '/membership/renew' : '/membership'))

const flags = useFlags()
const membershipEnabled = computed(() => isMembershipEnabled(flags.value))
</script>

<template>
  <ExternalLinkButton
    v-if="membershipEnabled"
    class="membership-link"
    hierarchy="inline"
    :href="href"
    intent="confirm"
    size="sm"
  >
    <slot />
  </ExternalLinkButton>
</template>
